import { Box, IconButton, useTheme } from "@mui/material";
import { FileText, X } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { ListRow } from "web_myplann/Shared/Components/ListRow";
import { formatFileSize } from "web_myplann/Shared/Utils/formatFileSize";

type Props = {
	file: File;
	filename: string;
	onRemove: () => void;
};

export const PickedFileRow: FC<Props> = ({ file, filename, onRemove }) => {
	const { palette, iconSize } = useTheme();
	const { t } = useResource();

	return (
		<Box bgcolor={palette.background.paper}>
			<ListRow
				icon={<FileText size={iconSize.md} color={palette.blue[600]} />}
				iconBg={palette.blue[100]}
				title={filename}
				subtitle={formatFileSize(file.size)}
				rightSlot={
					<IconButton
						aria-label={t(Resources.Portfolio.List.DocumentUpload.removeFile)}
						onClick={onRemove}
					>
						<X size={iconSize.sm} color={palette.grey[400]} />
					</IconButton>
				}
				isLast
			/>
		</Box>
	);
};
